/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-30 11:09:08
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-30 12:10:16
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/HtmlToText/index.tsx
 */
import { useHtml } from './useHtmlToText';
import React from 'react';
import { Skeleton, Text } from 'src/components/Antd';
import css from './css.module.less';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

const Html = (props) => {
  const { html, hasTooltip, width } = props;

  const { loaded, text } = useHtml({ html });
  const _text = React.useMemo(() => {
    const t = <Text>{text}</Text>;
    return hasTooltip ? (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{t}</GlobalTooltip>
      </NoWrapContainer>
    ) : (
      t
    );
  }, [hasTooltip, text]);

  return !loaded ? (
    <div className={css.container}>
      <Skeleton
        title={false}
        loading
        paragraph={{ rows: 1, width: width || 50 }}
      />
    </div>
  ) : (
    _text
  );
};
export default Html;
